/**
 * Das Logo, an einer Stelle.
 *
 * Vorher stand überall dort, wo die Marke auftauchte, ein Kegelverlauf als
 * Platzhalter: in der Kopfzeile, auf der Anmeldeseite, beim Assistenten. Jetzt
 * liegt das echte Bild dahinter, und weil es hier nur einmal beschrieben ist,
 * bleibt es an allen Stellen gleich.
 *
 * Die Bilddatei bringt ihren eigenen dunklen Hintergrund mit. Das passt zur
 * Anwendung, verlangt aber abgerundete Ecken und eine feine Kante in `--line`,
 * damit das Quadrat auf hellen Flächen nicht als Klotz aufliegt. Der farbige
 * Schein von früher ist weg: Farbe trägt jetzt Bedeutung (Akzent = läuft,
 * Hauptaktion), ein türkis-violetter Hof um die Marke hätte keine.
 */
export function Logo({
  size = 32,
  radius,
  full = false,
  style,
}: {
  size?: number;
  /** Eckenradius, ohne Angabe rund ein Drittel der Größe */
  radius?: number;
  /** Früher ein farbiger Schein; bleibt nur, damit alte Aufrufe kompilieren. */
  glow?: boolean;
  /** Das ganze Bild statt des quadratischen Ausschnitts */
  full?: boolean;
  style?: React.CSSProperties;
}) {
  return (
    <img
      src={full ? '/logo.webp' : '/logo-mark.webp'}
      alt="AI Feed Factory"
      width={size}
      height={full ? undefined : size}
      style={{
        width: size,
        height: full ? 'auto' : size,
        borderRadius: radius ?? Math.round(size / 3.2),
        flex: 'none',
        display: 'block',
        objectFit: 'cover',
        border: '1px solid var(--line)',
        ...style,
      }}
    />
  );
}
